import { put, post, get, del } from "@utils/axios";

const api = "case-management/status";

export const getCaseStatussReq = () => {
  return get(`${api}`);
}

export const createCaseStatusReq = (payload) => {
  return post(`${api}`, payload);
}

export const deleteCaseStatusReq = (id) => {
  return del(`${api}/${id}`);
}

export const updateCaseStatusReq = (payload) => {
  return put(`${api}/${payload.object.id}`, payload);
}

export const changeStatusReq = (payload) => {
  return post(`${api}-change`, payload);
}